import React from "react";
import { Loader, PartyPopper, Sparkles } from "lucide-react";
import { useBetaGate } from "../context/BetaGateContext";

/**
 * BetaWelcome — short celebration screen shown for ~2.5s after a successful
 * beta gate unlock, BEFORE the app routes through. Owned by GatedApp.
 */
export default function BetaWelcome() {
  const { betaEmail } = useBetaGate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: "#0F1B2D",
        backgroundImage:
          "radial-gradient(circle at 50% 20%, rgba(255,106,0,0.18), transparent 50%), radial-gradient(circle at 50% 90%, rgba(255,193,69,0.12), transparent 50%)",
      }}
      data-testid="beta-gate-welcome"
    >
      <style>{`
        @keyframes rm-welcome-pop {
          0% { opacity: 0; transform: translateY(12px) scale(0.94); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes rm-welcome-float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(3deg); }
        }
        @keyframes rm-welcome-shimmer {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        .rm-welcome-icon { animation: rm-welcome-float 1.8s ease-in-out infinite; }
      `}</style>

      <div
        className="w-full max-w-xl text-center"
        style={{ animation: "rm-welcome-pop 600ms cubic-bezier(.2,1.4,.4,1) both" }}
      >
        <div className="flex items-center justify-center gap-2 mb-4">
          <PartyPopper size={28} className="rm-text-orange rm-welcome-icon" />
          <span
            className="font-mono-rm text-xs uppercase tracking-widest"
            style={{ color: "#FFC145" }}
          >
            Access granted
          </span>
          <Sparkles size={22} style={{ color: "#FFC145" }} className="rm-welcome-icon" />
        </div>

        <h1
          className="font-display uppercase leading-none mb-5"
          style={{
            fontSize: "clamp(2.8rem, 7vw, 5.5rem)",
            letterSpacing: "-0.04em",
            color: "white",
          }}
          data-testid="beta-welcome-headline"
        >
          Welcome <span className="rm-text-orange">in.</span>
        </h1>

        <p className="text-base md:text-lg max-w-md mx-auto" style={{ color: "#CBD5E1" }}>
          Now let's give your career search the{" "}
          <strong
            style={{
              background:
                "linear-gradient(135deg, #FF8A33 0%, #FFC145 50%, #FF6A00 100%)",
              backgroundSize: "200% 100%",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              animation: "rm-welcome-shimmer 2.5s linear infinite",
            }}
          >
            makeover
          </strong>{" "}
          it deserves.
        </p>

        {betaEmail && (
          <p
            className="font-mono-rm text-xs uppercase tracking-widest mt-6"
            style={{ color: "#94A3B8" }}
          >
            Signed in as <span style={{ color: "white" }}>{betaEmail}</span>
          </p>
        )}

        <div className="mt-6">
          <Loader size={18} className="animate-spin mx-auto" style={{ color: "#FFC145" }} />
        </div>
      </div>
    </div>
  );
}
